// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__3M1aA","content":"LayoutSettings_content__2eyjg"};